/*global grecaptcha*/
import Utilities from '@/classes/Utilities.js';

export default class ReCaptcha {
    /**
     * Ready status
     * @var {Boolean}
     */
    static _ready = false;
    static _publicKey = '6LfZbjApAAAAADp-nK_kdFLfK7ZwqNc0RtFxyuVj';

    /**
     * Flag to check if we executed the
     * ready call
     * @var {Boolean}
     */
    static _didCheckReady = false;

    /**
     * Wait for the re-captcah to be ready
     * Use in async function as await ReCaptcha.ready()
     * @void
     */
    static async ready() {
        // avoid endless loop
        let count = 0;
        while (!ReCaptcha._ready) {
            // make sure the 
            if (!ReCaptcha._didCheckReady) {

                // make sure the script loaded
                if (window.grecaptcha) {

                    ReCaptcha._didCheckReady = true;
                    grecaptcha.ready(function() {
                        ReCaptcha._ready = true;
                    });
                }
            }
            await Utilities.sleep(25);
            count++;
            if (count > 1000) {
                break;
            }
        }

        return;
    }

    /**
     * Keep track of the tokens request
     * so we can use async functions
     * @var {Object}
     */
    static _tokens = {};

    /**
     * Sends an action and record the token
     * @var {String} action the action name
     * @return {Promise<String>} the token key to check
     */
    static async _action(action) {
        let key = Utilities.uniqueId('re-captcha');
        await ReCaptcha.ready();

        // we'll delete the key in 10 seconds
        grecaptcha.execute(ReCaptcha._publicKey, {action: action})
            .then(function(token) {
                ReCaptcha._tokens[key] = token;

                setTimeout(function() {
                    delete ReCaptcha._tokens[key];
                }, 10000); 
            });

        return key;
    }

    /**
     * Get the submit token
     * @return {Promise<String>} the token generated to recaptcha
     */
    static async submit() {
        let key = await ReCaptcha._action('submit');

        // avoid endless loop
        let count = 0;
        while (!ReCaptcha._tokens[key]) {
            await Utilities.sleep(25);
            count++;
            if (count > 100) {
                break;
            }
        }

        return ReCaptcha._tokens[key];

    }
}

